import React, { Component } from 'react'
import { connect } from 'react-redux'
import SelectCompany from '../../AcctMgt/component/ewCompanies'
import Spinner from './Spinner'
import { withRouter } from 'react-router-dom'
import FtpFolders from './ftpFolders'
import { saveUserFolders, toggleCreateFolder, toggleDeleteFolder, initializePage } from '../action/ftpFolderActions'
import UsersDD from './usersDD'
import { Navbar, Nav, } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
const navBtnStyle = { color: 'white', fontFamily: 'lato', fontWeight: 'bold', fontSize: '13px', borderRight: '1px solid #01265c' }

class FolderMgt extends Component {


  componentDidMount() {

    this.props.dispatch(initializePage())

  }

  render() {
    console.log('selected ', this.props.selectedCo)

    const Folders = (() => {
      if (this.props.selectedCo) {
        var code = this.props.selectedCo.company['Public Id of Distributor'] ?
          this.props.selectedCo.company['Public Id of Distributor'] :
          this.props.selectedCo.company['Public Id of Manufacturer']

        // this.props.dispatch(getUserFolders(code, this.props.users[0].FTP))
        if (this.props.user)
          return <FtpFolders code={code} userName={this.props.user['login']} FTP={this.props.user.FTP} />
      }
      return ''
    })


    return (<div>
      <Spinner />
      <Navbar style={{ background: '#265694', height: '45px' }} >
        <Navbar.Brand style={{ color: 'white' }} href="#home">FTP</Navbar.Brand>
        <table >
          <tbody>
            <tr>
              <td>
                <SelectCompany disabled={!this.props.userInfo.idea} style={{
                  fontFamily: 'lato', fontWeight: 'bold', fontSize: '13px', backgroundColor: 'hsla(0,0%,100%,.3)', border: 'none', textTransform: 'uppercase'
                }} ftp={true} />

              </td>
              <td>
                <UsersDD groups={this.props.groups} users={this.props.users} />


              </td>
            </tr>
          </tbody>
        </table>


        <Nav >

          <Nav.Link hidden={!this.props.user['login']} disabled={this.props.loading} onClick={() => {

            var code = this.props.selectedCo.company['Public Id of Distributor'] ?
              this.props.selectedCo.company['Public Id of Distributor'] :
              this.props.selectedCo.company['Public Id of Manufacturer']



            var input = {}
            input.publicCode = code
            input.companyName = this.props.selectedCo.company['Public Id of Distributor'] ?
              this.props.selectedCo.company['Distributor Name'] :
              this.props.selectedCo.company['Manufacturer Name']
            input.dirs = this.props.newAuthKeys
            input.userName = this.props.user['email']
            input.userId = this.props.user.userId
            this.props.dispatch(saveUserFolders(input, this.props.users))
          }} style={navBtnStyle}> <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faSave} />SAVE

</Nav.Link>


          <Nav.Link disabled={this.props.loading} onClick={() => {
            this.props.dispatch(toggleCreateFolder())
          }} style={navBtnStyle}> <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faPlus} />ADD

</Nav.Link>


          <Nav.Link disabled={this.props.loading} onClick={() => {
            this.props.dispatch(toggleDeleteFolder())
          }} style={navBtnStyle}> <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faTrash} />REMOVE

</Nav.Link>
        </Nav>



      </Navbar>



      <br />
      <Folders />

    </div>)
  }




}

const mapStateToProps = state => (
  {
    users: state.acct.user.filteredUsers || [],
    groups: state.acct.ewGroup.groups,
    selectedCo: state.acct.ewCo.globalSelect,
    user: state.acct.user.selectedUser || {},
    cos: state.acct.ewCo.companies,
    newAuthKeys: state.ftp.folder.newAuthKeys,
    loading: state.ftp.folder.loading,
    userInfo: state.acct.user.userInfo

  });



export default withRouter(connect(mapStateToProps)(FolderMgt))